export default __webpack_public_path__ + "static/HelveticaNeueLTStd-Lt-4e9f9e83e4d674fbcdbe72492f021665.otf";